import { ChangeEvent, useCallback, useEffect } from "react";
import { UpdateAttribute } from "../../../../hooks/attributes/useAttributes";
import { LayerAttribute } from "../components/Layer/LayerAttributeItem";

type LayerAttributeUpdate = {
  toggleDisplayed: VoidFunction;
  updateAlias: (e: ChangeEvent<HTMLInputElement>) => void;
  hideWithClassification: VoidFunction;
};

export const useLayerAttributeUpdate = (
  displayField: string,
  attribute: LayerAttribute,
  setDisplayField: (name: string) => void,
  updateAttribute: UpdateAttribute<LayerAttribute>,
  firstVisibleAttribute: LayerAttribute | undefined,
  toggleHiddenDialog,
): LayerAttributeUpdate => {
  const { attributeName, id, isDisplayed, classified, resetClassification } = attribute;

  const hideWithClassification = useCallback(() => {
    updateAttribute(id, {
      isDisplayed: !isDisplayed,
      resetClassification: true,
    });
    toggleHiddenDialog();
  }, [id, isDisplayed, toggleHiddenDialog, updateAttribute]);

  const toggleDisplayed = useCallback(() => {
    if (isDisplayed && classified) {
      toggleHiddenDialog();
    } else {
      updateAttribute(id, {
        isDisplayed: !isDisplayed,
        resetClassification: classified ? false : resetClassification,
      });
    }
  }, [id, isDisplayed, classified, resetClassification, toggleHiddenDialog, updateAttribute]);

  useEffect(() => {
    if (!isDisplayed && displayField === attributeName) {
      const newDisplayField = firstVisibleAttribute ? firstVisibleAttribute.attributeName : null;

      setDisplayField(newDisplayField);
    }
  }, [isDisplayed]);

  const updateAlias = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => updateAttribute(id, { alias: e.target.value }),
    [id, updateAttribute],
  );

  return { toggleDisplayed, updateAlias, hideWithClassification };
};
